export const HOLIDAY_START_YEAR = 2024;

/** Returns an ascending list of years from HOLIDAY_START_YEAR to current year + 1. */
export function getHolidayYears(): number[] {
  const end = new Date().getFullYear() + 1;
  const years: number[] = [];
  for (let y = HOLIDAY_START_YEAR; y <= end; y++) {
    years.push(y);
  }
  return years;
}
